module.exports = __webpack_public_path__ + "visa-icon@2x.png?fd83ee8d14a96646c98438ccb2e15db0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visa-icon@2x.png
// module id = 1038
// module chunks = 0